
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/data-extraction",
      function () {
        return require("private-next-pages/syncs/data-extraction.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/data-extraction"])
      });
    }
  